import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import SvgIcon from "@mui/material/SvgIcon";

import {cartItemInStock, filterCartItems} from "../../lookNavigation/lookFunctions2";
import {LookCartIcon} from "../../../common/icons";
import GroheCartColumns from "./groheCartColumns";

const GroheCartFooter = (props) => {

  const {cartItems, isMobile, cartFooterCheckoutClick, showUnlockCalculations, showTotalItems} = props;

  const cartItemsToInclude = filterCartItems(cartItems);

  const disabled = cartItemsToInclude.every(cartItem => !cartItemInStock(cartItem))
    || cartItemsToInclude.filter(cartItem => cartItemInStock(cartItem)).every(cartItem => !cartItem.quantity);

  return (
    <footer className="gc-footer">
      <GroheCartColumns isShort={true}/>
      {isMobile || (showUnlockCalculations && !showTotalItems.includes("checkout")) ? null : (
        <div className="gc-footer__item">
          <Button className="look-button look-button--blue look-button--big look-button--large nowrap"
                  disabled={disabled}
                  startIcon={<SvgIcon><LookCartIcon /></SvgIcon>}
                  onClick={cartFooterCheckoutClick}>
            <FormattedMessage id="buttons.checkout"/>
          </Button>
        </div>
      )}
    </footer>
  )
};

GroheCartFooter.propTypes = {
  cartFooterCheckoutClick: PropTypes.func.isRequired
}

const mapStateToProps = (store) => {
  const {cartItems} = store.cartState;
  const {isMobile} = store.serverState;
  const {showUnlockCalculations, showTotalItems} = store.unlockCalculationsState;

  return {
    cartItems,
    isMobile,
    showUnlockCalculations,
    showTotalItems,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GroheCartFooter)
